import * as React from "react";
import { Grid, TablePagination, Typography, Fab } from "@material-ui/core";
import * as Styles from "./styles/AlertsSearchStyles";
import { useState } from "react";
import { LoadingComponent } from "../loading/LoadingComponent";
import * as GlobalAlertService from "../../services/GlobalAlertService";
import useDebounce from "../../hooks/useDebounce";
import AddIcon from "@material-ui/icons/Add";
import { AlertList } from "./AlertList";
import { useHistory } from "react-router-dom";
import { IGlobalAlert } from "../../interfaces/global-alerts/IGlobalAlert";

const results: Array<IGlobalAlert> = [];

export const AlertsListContainer: React.FC = () => {
    const classes = Styles.AlertsSearchStyles();
    const [searchResults, setSearchResults] = useState(results);
    const [searchText, setSearchText] = useState<string>("");
    const [isLoading, setIsLoading] = React.useState(true);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchResultCount, setSearchResultCount] = React.useState(0);

    const debouncedSearch = useDebounce(searchText, 800);
    const history = useHistory();

    React.useEffect(() => {
        if (debouncedSearch !== undefined) {
            search();
        }
    }, [debouncedSearch, rowsPerPage, page]);


    const search = () => {
        GlobalAlertService.Search({
            search: debouncedSearch,
            pageSize: rowsPerPage,
            pageNumber: page,
        })
            .then(result => {
                if (result.parsedBody !== undefined) {
                    setSearchResults(result.parsedBody.results);
                    setSearchResultCount(result.parsedBody.resultCount);
                    setIsLoading(false);
                }
            })
            .catch(async response => {
                console.log("error searching:" + response);
            });
    };


    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        setIsLoading(true);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        setIsLoading(true);
    };

    return (
        <Grid>
            <Grid item xs={12} style={{ textAlign: "end" }}>
                <Fab
                    color="primary"
                    aria-label="add"
                    size="medium"
                    variant="extended"
                    onClick={() => history.push(`/Alerts/Create`)}
                    style={{ marginLeft: "8px" }}
                >
                    <AddIcon />
                    <Typography variant="button" display="inline">
                        Create Alert
                    </Typography>
                </Fab>
            </Grid>



            {isLoading ? (
                <LoadingComponent label="Loading alerts" />
            ) : (
                <>
                    <Grid item xs={12} className={classes.results}>
                        <AlertList results={searchResults} refresh={search} />
                    </Grid>
                    <Grid item xs={12}>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={searchResultCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};
